export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  storageContainer: process.env.REACT_APP_STORAGE_CONTAINER,
}
